'use strict';

function _LoanOfferReupController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();
    this._hist = new History();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._catchInvalidRequest();
  };

  this._catchInvalidRequest = function () {
    if (this._activeOffer.getOfferData() && this._activeOffer.getOfferData().name !== 'lendful') {
      this._hist.goToUrl('/member/dashboard/home');
    }
  };

  this.destroy = function () {
    this._super();
  };
}